import React, { ReactNode } from 'react';

import { bemCssModules } from '@utils';

import Illustration from '@components/Illustration';

import LoaderImage from './circle_pause.svg';

import style from './Banner.scss';

const cn = bemCssModules(style, 'Banner');

interface TBannerCommonProps {
  title?: string;
  subtitle?: string;
  onClick?: () => void;
}

type TBannerTruncateProps =
  | {
      isLoading?: false;
      images?: ReactNode[];
      mobileImages?: ReactNode[] | false;
      bottomImage?: boolean;
    }
  | { isLoading: true; images?: never; mobileImages?: never; bottomImage?: never };

export type TBanner = TBannerCommonProps & TBannerTruncateProps;

const Banner: CustomFC<TBanner> = props => {
  const { className, title, subtitle, images, mobileImages, isLoading, bottomImage, onClick } =
    props;

  const isMobile = !!mobileImages;

  return (
    <div
      className={cn({ isMobile, isLoading, clickable: !!onClick }, [className])}
      onClick={onClick}
      aria-hidden="true"
    >
      <div
        className={cn('content', {
          isMobile,
          bottomImage: bottomImage && isMobile,
          isLoading,
        })}
      >
        <div className={cn('title', { isMobile })}>{title}</div>
        {subtitle && <div className={cn('subtitle')}>{subtitle}</div>}
      </div>
      {isLoading ? (
        <LoaderImage className={cn('loader')} />
      ) : (
        <>
          {images && <Illustration className={cn('image')} images={images} />}
          {mobileImages && (
            <Illustration className={cn('mobile-image', { bottomImage })} images={mobileImages} />
          )}
        </>
      )}
    </div>
  );
};

export default Banner;
